exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2XsXosfdbDE2kU{padding-bottom:24px}", ""]);

// exports
exports.locals = {
	"boardSection": "_2XsXosfdbDE2kU"
};